import { render } from "./InvoiceOverviewPage.vue?vue&type=template&id=872ab372&scoped=true"
import script from "./InvoiceOverviewPage.vue?vue&type=script&lang=js"
export * from "./InvoiceOverviewPage.vue?vue&type=script&lang=js"

import "./InvoiceOverviewPage.vue?vue&type=style&index=0&id=872ab372&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-872ab372"]])

export default __exports__